import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.table = [];
    this.cardsLayout = [
      // cards
      {
        title: "Card1",
        hideTitle: true,
        items: [
          {
            label: {
              value: "Navis Ref ID",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "navisRefID"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Customer Ref ID",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "customerRefID"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Final Seal #",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "finalSeal"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Navis Date",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "navisDate"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Destination",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "destination"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Container/Tracking #",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "containerTrk"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Load Port",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "loadPort"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Discharge Port",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "dischargePort"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Size",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "containerSize"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Vessel/Carrier",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vesselCarrier"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "US Carrier",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "usCarrier"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Stacking",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "stacking"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "ASN Qty Order",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "asnQtyOrdered"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "ASN Qty Shipped",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "asnQtyShipped"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Container Load",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "containerLoad"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Country of Origin",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "countryOrg"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Appoint D/T",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "appointDT"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Total Cases",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "totalCases"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Origin Seal #",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "orgSeal"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Action DT",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "actionDT"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Other Info",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "otherInfo"
            },
            readOnly: true,
            size: "calc(100% / 3)"
          }
        ]
      },
      {
        title: "Status Dates",
        items: [
          {
            label: {
              value: "Factory Ship",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "factoryShipAct"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "US Customs",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "usCustomsAct"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "CFS Arrival",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cfsArrivalAct"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "DC Arrival",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "dcArrivalAct"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "Export Load",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "exportLoadAct"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "Gate in D/T",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "gateInDT"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "Export Ship",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "exportShipAct"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "Gate Out D/T",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "gateOutDT"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "US Arrival",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "usArrivalAct"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          },
          {
            label: {
              value: "CU Rel Date",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cuRelDate"
            },
            readOnly: true,
            size: "calc(100% / 2)"
          }
        ]
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];

        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value = props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.checked = props[c][inputName][i].checked;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
            item.item.injectedValue = props[c][inputName][i].injectedValue;
          }

          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);

    return (
      <Fragment>
        <div style={{ flex: 1, display: "flex" }}>
          <InputCard
            flex={1.77}
            jsonObj={this.cardsLayout[0]}
            setCardsInfo={this.getCardsInfo}
            functions={{
              checkOrderConstraints: this.props.checkOrderConstraints
            }}
          />
          <InputCard
            flex={1}
            jsonObj={this.cardsLayout[1]}
            setCardsInfo={this.getCardsInfo}
            functions={{
              checkOrderConstraints: this.props.checkOrderConstraints
            }}
          />
        </div>
      </Fragment>
    );
  };

  getTheJson = () => {
    for (let index = 0; index < this.cardsLayout.length; index++) {
      for (let i = 0; i < this.cardsLayout[index].items.length; i++) {
   
      }
    }
  };
  render() {
    return (
      <Fragment>
        {/* <button onClick={e => this.getTheJson()} /> */}
        <div className="cards-container" style={{ display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
